export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/tijnxqj8_Universal%20House.png",
  rooms: {
    shrek: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/85qkmudu_Shrek%20Main.JPG",
    spongebob: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/eayibrwk_Spongebob%20Main.JPG",
    trolls: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/ub0imu54_Trolls%20Main.JPG",
    minions: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/comnygmk_Minion%20Main.JPG",
  },
};

export const BRAND_COLORS = ["#FF4D4D", "#FFD166", "#06D6A0", "#3B82F6", "#9D4EDD", "#EF476F"];

export const ROOMS = [
  {
    key: "spongebob",
    name: "SpongeBob Room",
    tagline: "Bikini Bottom Themed Fun",
    description: "Dive into a sun-drenched undersea hideaway with playful flower walls, pineapple sheets, and a cozy queen bed.",
    features: ["Queen Bed", "Underwater Mural", "Pineapple Sheets", "Smart TV"],
    image: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/eayibrwk_Spongebob%20Main.JPG",
    bg: "#E0F7FA",
    border: "#00B4D8",
    accent: "#FFD166",
    emoji: "🍍",
  },
  {
    key: "trolls",
    name: "Trolls Room",
    tagline: "Trollstopia Twin Suite",
    description: "Glittering pinks, party greens and a hand-painted Trolls village. Two beds for double the giggles.",
    features: ["Twin Bed", "Bright Colors", "Mural Wall", "Dance Party Ready"],
    image: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/ub0imu54_Trolls%20Main.JPG",
    bg: "#FCE4EC",
    border: "#F06292",
    accent: "#06D6A0",
    emoji: "🌈",
  },
  {
    key: "shrek",
    name: "Shrek Room",
    tagline: "The Swamp Master Suite",
    description: "A rustic ogre's lair with a hand-built log king bed, swamp mural, and nostalgic decor for the parents.",
    features: ["King Bed", "Hand-Built Frame", "Swamp Mural", "Smart TV"],
    image: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/85qkmudu_Shrek%20Main.JPG",
    bg: "#F1F8E9",
    border: "#689F38",
    accent: "#DDA15E",
    emoji: "🟢",
  },
  {
    key: "minions",
    name: "Minions Room",
    tagline: "Minion Madness",
    description: "Banana-yellow bunks under a glowing starry ceiling. Two bunks + a beanbag = up to 4 sleepy minions.",
    features: ["2 Bunk Beds (4 sleepers)", "Glow Ceiling", "Bean Bag", "Perfect for kids"],
    image: "https://customer-assets.emergentagent.com/job_frisco-sleepover-hub/artifacts/comnygmk_Minion%20Main.JPG",
    bg: "#FFF9C4",
    border: "#FBC02D",
    accent: "#118AB2",
    emoji: "🍌",
  },
];

export const AMENITIES = [
  { icon: "Wifi", title: "High-Speed Wi-Fi", color: "#3B82F6" },
  { icon: "ChefHat", title: "Fully Stocked Kitchen", color: "#FF4D4D" },
  { icon: "Baby", title: "High Chair for Little Ones", color: "#9D4EDD" },
  { icon: "Tv", title: "3 Smart TVs", color: "#118AB2" },
  { icon: "Paddle", title: "Ping Pong in Garage", color: "#06D6A0" },
  { icon: "Dices", title: "Dozens of Board Games", color: "#EF476F" },
  { icon: "Trees", title: "Yard with Cornhole & Ladderball", color: "#FFD166" },
  { icon: "Utensils", title: "Outdoor Picnic Table", color: "#F06292" },
  { icon: "UtensilsCrossed", title: "Large Dining Table", color: "#00B4D8" },
];

export const ATTRACTIONS = [
  { time: "12 min", name: "Universal Kids Resort", desc: "Drive to the brand new Universal park" },
  { time: "10 min", name: "The Star (Cowboys HQ)", desc: "Dining, shopping & events" },
  { time: "15 min", name: "Frisco RoughRiders", desc: "Family-friendly minor league baseball" },
  { time: "5 min", name: "Top-Rated Restaurants", desc: "Surrounded by family eats" },
  { time: "25 min", name: "Downtown Dallas", desc: "Museums, aquarium & skyline views" },
  { time: "20 min", name: "DFW Airport", desc: "Easy in, easy out" },
];

export const REVIEWS = [
  {
    name: "Keith and Beth",
    tenure: "5 years on Airbnb",
    rating: 5,
    date: "2 weeks ago",
    trip: "Stayed with kids",
    text: "We loved this themed house! We needed a big enough space for our family to visit but also be near something fun for the kids to be excited about. (Universal Kids) Our grands even said this place felt like home and they didn't want to leave it. We loved the welcoming and cozy touches from snacks to blankets and even a scavenger hunt for the kids to do! Highly recommend this place!",
    color: "#06D6A0",
  },
  {
    name: "Christopher",
    tenure: "4 years on Airbnb",
    rating: 5,
    date: "August 2026",
    trip: "Stayed with kids",
    text: "Spacious and super fun for the kids!",
    color: "#FFD166",
  },
];

export const FACTS = [
  "Sleeps up to 12",
  "4 Themed Bedrooms",
  "2 Full Bathrooms",
  "12 min to Universal Kids Resort",
  "25 min to Downtown Dallas",
  "Quiet Frisco Neighborhood",
];
